/**
 * Reads JWT payload (no signature verification — for client-side session hints only).
 */
function parseJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    const b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const pad = b64.length % 4;
    const padded = pad ? b64 + "=".repeat(4 - pad) : b64;
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

function isMongoObjectIdString(value) {
  return typeof value === "string" && /^[a-f0-9]{24}$/i.test(value);
}

/**
 * Ensures dashboard `adminId` in localStorage matches a valid Mongo id from the access token.
 * Fixes `.../find-admin-role-permissions-by-id/${null}` becoming the literal path segment "null".
 */
function syncDashboardAdminIdFromAccessToken(accessToken) {
  const payload = parseJwtPayload(accessToken);
  if (!payload || payload.id == null) return;
  const id = String(payload.id).trim();
  if (!isMongoObjectIdString(id)) return;
  const current = localStorage.getItem("adminId");
  if (!isMongoObjectIdString(current || "")) {
    localStorage.setItem("adminId", id);
  }
}

module.exports = {
  parseJwtPayload,
  isMongoObjectIdString,
  syncDashboardAdminIdFromAccessToken,
};
